<template>
  <q-card
    flat
    class="storyCard"
    :class="{
      'bg-lightGrey': greyBG,
    }"
    :style="`width: 275px; height: 166px`"
  >
    <q-card-section
      v-if="data"
      class="q-py-sm q-px-md"
      :style="`background: ${
        currentOutcome ? currentOutcome.primaryColor : ''
      }`"
    >
      <div class="row items-center">
        <div class="col text-white" style="font-size: 10px; font-weight: bold">
          {{ $options.filters.articleCardDate(data.created_at) }}
        </div>
        <div class="col-auto">
          <q-img
            :src="getOutcomeImage({ name: data.outcomeName })"
            style="width: 20px"
          ></q-img>
        </div>
      </div>
    </q-card-section>
    <q-card-section v-if="data">
      <div class="row">
        <div class="col-12">
          <h4 class="q-my-none" style="font-size: 0.8rem">
            {{ data.title }}
          </h4>
        </div>
        <div class="col-12 q-py-sm"></div>
        <!-- <div class="col-12 q-py-sm" v-html="data.description"></div> -->
        <div class="col-12 q-pt-sm">
          Posted {{ data.created_at | momentFormatRelativeTime }}
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>

<script>
  import { mapGetters } from "vuex";
  import { getCSSVars } from "@/functions/cssVars";
  import { getOutcomeImage } from "@/functions/getOutcomeImage";

  export default {
    props: {
      data: {
        default: null,
      },
      largeVersion: {
        default: true,
        type: Boolean,
      },
      greyBG: {
        default: false,
        type: Boolean,
      },
    },
    computed: {
      ...mapGetters({
        outcomes: "outcomes/list",
      }),
      currentOutcome() {
        return this.outcomes.find((o) => o.id == this.data.outcomes_id);
      },
      cssVars() {
        let outcome = this.selectedOutcome;
        return getCSSVars(outcome);
      },
    },

    data: () => ({}),
    watch: {},
    async mounted() {},
    methods: {
      getOutcomeImage: getOutcomeImage,
      getCSSVars: getCSSVars,
    },
  };
</script>

<style lang="scss" scoped>
  .storyCard {
    h4 {
      font-size: 1rem;
      font-weight: 600;
      color: $accent;
      line-height: 1.1rem;
    }
  }
</style>
